import SiteCollectionAdminAdded from './SiteCollectionAdminAdded';

const SharePointSharingOperation = {
    SiteCollectionAdminAdded,
};

export default SharePointSharingOperation;
